<ng-container *transloco="let t; prefix: 'reception'">
    <div class="reception-container d-flex justify-content-center py-4">
        <div class="reception-card-container">
            <div class="row g-4" @easeIn>
                <div class="col-12">
                    <div class="card schemas text-decoration-none" (click)="onSchemaClick()" [ariaLabel]="t('schemaboxtitle')" tabindex="0">
                        <div class="card-body align-content-center">
                            <div class="row">
                                <div class="col-auto d-flex justify-content-center align-items-center">
                                    <i class="fa-solid fa-notes-medical"></i>
                                </div>
                                <div class="col">
                                    <h5 class="card-title ">{{ t('schemaboxtitle') }}</h5>
                                    <p class="card-text">{{ t('schemaboxtext') }}</p>
                                </div>
                                <div class="col-auto d-flex justify-content-center align-items-center">
                                    <i class="fa-solid fa-arrow-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card fogp text-decoration-none" (click)="onFogpFormsClick()" [ariaLabel]="t('fogpboxtitle')" tabindex="0">
                        <div class="card-body align-content-center">
                            <div class="row">
                                <div class="col-auto d-flex justify-content-center align-items-center">
                                    <i class="fa-solid fa-pen"></i>
                                </div>
                                <div class="col">
                                    <h5 class="card-title ">{{ t('fogpboxtitle') }}</h5>
                                    <p class="card-text">{{ t('fogpboxtext') }}</p>
                                </div>
                                <div class="col-auto d-flex justify-content-center align-items-center">
                                    <i class="fa-solid fa-arrow-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</ng-container>